import { ref, isRef, unref } from 'vue';

export function useClosable(modelValue = false) {
    const initialValue = isRef(modelValue) ? unref(modelValue) : modelValue;
    const isOpen = ref(!!initialValue);
    const payload = ref(null);

    const open = (p = {}) => {
        payload.value = p;
        
        if (!isOpen.value) {
            isOpen.value = true;
        }
    };

    const close = () => {
        if (isOpen.value) {
            isOpen.value = false;
        }
    };

    return {
        isOpen,
        payload,
        open,
        close,
    };
}

